import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoginPageComponent } from './login-page/login-page.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { ForgetPasswordComponent } from './forget-password/forget-password.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { MaintenancePageComponent } from './maintenance-page/maintenance-page.component';
import { AccessDeniedComponent } from './access-denied/access-denied.component';
import { MfaChallengeComponent } from './mfa-challenge/mfa-challenge.component';
import { AuthErrorBannerComponent } from 'src/app/ui/auth-layout/auth-error-banner.component';
import { AuthLayoutComponent } from 'src/app/ui/auth-layout/auth-layout.component';
import { ButtonComponent } from 'src/app/ui/button/button.component';
import { FormFieldComponent } from 'src/app/ui/form-field/form-field.component';
// SharedModule exports the legacy `app-svg-icon`; these pages use the `ui-` one.
import { SvgIconComponent } from 'src/app/ui/svg-icon/svg-icon.component';



@NgModule({
  declarations: [
    LoginPageComponent,
    ForgetPasswordComponent,
    ResetPasswordComponent,
    MaintenancePageComponent,
    AccessDeniedComponent,
    MfaChallengeComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
    AuthErrorBannerComponent,
    AuthLayoutComponent,
    ButtonComponent,
    FormFieldComponent,
    SvgIconComponent,
  ],
  exports: [MaintenancePageComponent, AccessDeniedComponent]
})
export class AuthenticationModule { }
